import { c as _c } from "react/compiler-runtime";
import { useSelector } from '@legendapp/state/react';
import { ReactiveMotionDiv } from '@/components/ReactiveMotionDiv';
import type { PageSubNavIndicatorState } from './useInitSubNav';
export type PageSubNavIndicatorProps = {
  indicatorState$: PageSubNavIndicatorState['indicatorState'];
};
export function PageSubNavIndicator(t0) {
  const $ = _c(19);
  const {
    indicatorState$
  } = t0;
  let t1;
  if ($[0] !== indicatorState$.enabled) {
    t1 = () => indicatorState$.enabled.get();
    $[0] = indicatorState$.enabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enabled = useSelector(t1);
  if (!enabled) {
    return null;
  }
  let t2;
  if ($[2] !== indicatorState$.top) {
    t2 = indicatorState$.top.get() || 0;
    $[2] = indicatorState$.top;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== indicatorState$.width) {
    t3 = indicatorState$.width.get() || 0;
    $[4] = indicatorState$.width;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== indicatorState$.left) {
    t4 = indicatorState$.left.get() || 0;
    $[6] = indicatorState$.left;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      left: 0,
      top: t2,
      width: t3,
      x: t4
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== indicatorState$.left || $[13] !== indicatorState$.top || $[14] !== indicatorState$.width) {
    t6 = () => {
      const left = indicatorState$.left.get();
      const width = indicatorState$.width.get();
      if (width === undefined || left === undefined) {
        return {
          left: 0,
          display: "none"
        };
      }
      return {
        top: indicatorState$.top.get() || 0,
        left: 0,
        width,
        x: left,
        display: "block"
      };
    };
    $[12] = indicatorState$.left;
    $[13] = indicatorState$.top;
    $[14] = indicatorState$.width;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <ReactiveMotionDiv className="tab bg-primary rounded-full absolute z-0 px-4 py-2 hidden" initial={t5} $animate={t6}> </ReactiveMotionDiv>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}